<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { subscriptionService } from "../../services";
import DropzonePopup from "../../components/widgets/dropzone-popup";
import draggable from "vuedraggable";
import moment from "moment";
import { debounce } from "../../Helper/helper";
import product from "./subscription_tabs/Product.vue";

export default {
  components: {
    Layout,
    PageHeader,
    pagination,
    subscriptionService,
    DropzonePopup,
    draggable,
    moment,
    product,
  },
  data() {
    const { status, type, orderBy, sortBy } = this.$route.query;
    return {
      title: this.trans.get("__JSON__.Sub Products"),
      url: null,
      debounce: false,
      items: [],
      checked: true,
      sortBy: sortBy || "created_at",
      type: type || "1",
      sortDesc: orderBy && orderBy != "" ? true : orderBy,
      loading: true,
      paginations: {},
      product: {},
      subProduct: {},
      limit: 1,
      search: "",
      status: status == undefined ? "1" : status,
      config: config,
      productount: "",
      subscription: [],
      subscription_id: this.$route.params.subscription_id,
      init: true,
      searchData: debounce(() => {
        if (!this.init) {
          const { status, type, orderBy, sortBy } = this.$data;
          this.$router.replace({
            name: "subscription-product-list",
            query: { status, type, orderBy, sortBy },
          });
        }
        this.getSubscriptionProduct();
        this.init = false;
      }, 500),

      fields: [
        { key: "sub_product_id", label: "#", sortable: false,thClass:"dis-event" },
        { key: "product_name", label: "Product name", sortable: false,thClass:"dis-event" },
        { key: "sub_product_name", label: "Sub product Name", sortable: false,thClass:"dis-event" },
        { key: "quantity", label: "Quantity", sortable: false,thClass:"dis-event" },
        // { key: "price", label: "Original", sortable: false },
      ],
    };
  },
  mounted() {
    this.getSubscriptionProduct();
    this.getSubscriptionById();
  },
  methods: {
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getSubscriptionProduct();
    },
    getSubscriptionProduct(page) {
      this.loading = true;
      subscriptionService
        .getSubscriptionProduct({
          search: this.search,
          status: this.status,
          type: this.type,
          sortBy: this.sortBy,
          orderBy: this.sortDesc ? "desc" : "asc",
          page: page && page > 0 ? page : 1,
          subscription_id: this.subscription_id,
        })
        .then((response) => {
          this.loading = false;
          this.paginations = response.data.result;
          this.items = response.data.result.data;
          this.productount = response.data.result.data.length;
        });
    },
    getSubscriptionById() {
      this.loading = true;
      subscriptionService
        .getSubscriptionById({ subscription_id: this.subscription_id })
        .then(({ data }) => {
          this.subscription = data.result;
        });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div
          class="
            page-title-box
            d-flex
            align-items-center
            justify-content-between
            icon-main-page
          "
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-soft-primary
                  text-primary
                  font-size-18
                "
              >
                <i class="bx bx-store"></i>
              </span>
            </div>
            <div class="report-tag">
              <p> <h4 class="mb-0 font-size-18">{{ subscription.customer_name }}</h4> <router-link :to="{ name: 'subscription-list' }">{{
                  trans.get("__JSON__.Subscriptions")
                }}</router-link> > {{ subscription.customer_name }}
                > {{ trans.trans('__JSON__.Products') }} ({{productount}})
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row list-table-main">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <div class="row">
              <div class="col-sm-2 offset-sm-8">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>{{ trans.get("__JSON__.Status") }} :</label>
                    <select
                      class="custom-select"
                      v-model="status"
                      @change="searchData()"
                    >
                      <option value="">{{ trans.get("__JSON__.All") }}</option>
                      <option value="1" selected>
                        {{ trans.get("__JSON__.Active") }}
                      </option>
                      <option value="0">
                        {{ trans.get("__JSON__.Inactive") }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="date-range-list">
                  <label>{{ trans.get("__JSON__.Search") }} :</label>
                  <div class="text-sm-right">
                    <div class="search-box mr-2 d-inline-block">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="
                            trans.get('__JSON__.Search Placeholder')
                          "
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <b-tabs
              justified
              nav-class="nav-tabs-custom mt-0 order-tabs"
              content-class="p-3 text-muted"
              lazy
            >
              <b-tab @sorting="sortingChanged">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-plus"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    trans.get("__JSON__.Products")
                  }}</span>
                </template>

                <div class="row">
                  <div
                    class="
                      col-12
                      table-main-list
                      customer-table
                      table-responsive
                    "
                  >
                    <b-table
                      :items="items"
                      :fields="fields"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :no-local-sorting="true"
                      @sort-changed="sortingChanged"
                      :busy="loading"
                      show-empty
                    >
                      <template #table-busy>
                        <div class="text-center text-danger my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>{{
                            trans.get("__JSON__.Loading...")
                          }}</strong>
                        </div>
                      </template>

                      <template v-slot:cell(id)="data">
                        <h5 class="font-size-14">{{ data.item.sub_id }}</h5>
                      </template>

                      <template v-slot:cell(customer_name)="data">
                        <h5 class="font-size-14">
                          {{ data.item.customer_name }}
                        </h5>
                      </template>

                      <template v-slot:cell(name)="data">
                        <span>{{ data.item.unit + " " + data.item.type }}</span>
                      </template>

                      <template v-slot:cell(discount)="data">
                        <span>{{ data.item.discount }}</span>
                      </template>

                      <template v-slot:cell(start_date)="data">
                        <div v-if="data.item.start_date">
                          {{
                            moment(data.item.start_date).format(
                              "D MMM,Y HH:mm A"
                            )
                          }}
                        </div>
                      </template>

                      <template v-slot:cell(user_role)="data">
                        <div
                          v-if="data.item.user_role === '1'"
                          class="
                            badge badge-pill badge-soft-danger
                            font-size-12
                          "
                        >
                          {{ trans.get("__JSON__.Private") }}
                        </div>
                        <div
                          v-if="data.item.user_role === '5'"
                          class="
                            badge badge-pill badge-soft-success
                            font-size-12
                          "
                        >
                          {{ trans.get("__JSON__.Business") }}
                        </div>
                      </template>

                      <template v-slot:cell(status)="data">
                        <div
                          v-if="data.item.status === '0'"
                          class="
                            badge badge-pill badge-soft-danger
                            font-size-12
                          "
                        >
                          {{ trans.get("__JSON__.Inactive") }}
                        </div>
                        <div
                          v-else
                          class="
                            badge badge-pill badge-soft-success
                            font-size-12
                          "
                        >
                          {{ trans.get("__JSON__.Active") }}
                        </div>
                      </template>

                      <template v-slot:cell(action)="data">
                        <!-- <router-link
                      :to="{
                        name: 'sub-product-edit',
                        params: { id: base64(data.item.sub_id) },
                      }"
                      class="btn btn-success btn-sm btn-rounded"
                      >Edit</router-link
                    > -->

                        <router-link
                          :to="{
                            name: 'subscription-product-list',
                            params: {
                              subscription_id: base64(data.item.sub_id),
                            },
                          }"
                          class="btn btn-primary btn-sm btn-rounded"
                          >View</router-link
                        >

                        <!-- <button
                      type="submit"
                      @click="deleteSubProduct(base64(data.item.sub_id))"
                      class="btn btn-danger btn-sm btn-rounded ml-1"
                    >
                      {{ trans.get("__JSON__.Delete") }}
                    </button> -->
                      </template>

                      <template #empty>
                        <p class="text-center">
                          {{ trans.get("__JSON__.No Subscription") }}
                        </p>
                      </template>
                    </b-table>
                  </div>
                  <div class="row col-sm-5 offset-sm-7">
                    <div class="col">
                      <div
                        class="
                          dataTables_paginate
                          paging_simple_numbers
                          float-right
                        "
                      >
                        <ul class="pagination pagination-rounded mb-0">
                          <!-- pagination -->
                          <pagination
                            :data="paginations"
                            :limit="limit"
                            @pagination-change-page="getSubscriptionProduct"
                          ></pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab @sorting="sortingChanged">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-plus"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    trans.get("__JSON__.Details")
                  }}</span>
                </template>

                <form action="">
                  <div class="card">
                    <div class="card">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label for="">{{
                              trans.get("__JSON__.Customer Name")
                            }}</label>
                            <p class="form-control">
                              {{ this.subscription.customer_name }}
                            </p>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label for="">{{
                              trans.get("__JSON__.Customer Type")
                            }}</label>
                            <p class="form-control">
                              {{
                                this.subscription.user_role == "1"
                                  ? "Private"
                                  : "Business"
                              }}
                            </p>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label for="">{{
                              trans.get("__JSON__.Subscription Type")
                            }}</label>
                            <p class="form-control">
                              {{ this.subscription.subscription_type }}
                            </p>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label for="">{{
                              trans.get("__JSON__.Order Type")
                            }}</label>
                            <p class="form-control">
                              {{
                                this.subscription.delivery_type == "1"
                                  ? "Delivery"
                                  : "Pickup"
                              }}
                            </p>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label for="">{{
                              trans.get("__JSON__.Time Slot")
                            }}</label>
                            <p class="form-control">
                              {{
                                `${this.subscription.from_time} - ${this.subscription.to_time}`
                              }}
                            </p>
                          </div>
                        </div>

                        <!-- <div class="col-sm-6">
                          <div class="form-group">
                            <label for="">Type</label>
                            <p class="form-control">10:00 pm</p>
                          </div>
                        </div> -->

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label for="">{{
                              trans.get("__JSON__.Upcomming order date")
                            }}</label>
                            <p class="form-control">
                              {{ this.subscription.next_date }}
                            </p>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label for="">{{
                              trans.get("__JSON__.Address")
                            }}</label>
                            <p class="form-control">
                              {{ this.subscription.address }}
                            </p>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label for="">{{
                              trans.get("__JSON__.Payment Method")
                            }}</label>
                            <p class="form-control">
                              {{ this.subscription.payment_method }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>